import Input from "@hudson/ui/components/FormFields/Input";
import Field from "@hudson/ui/components/FormFields/Field";

export default function LinkGroupField({
  autoFocus,
  className = "",
  errorMessage,
  fieldName,
  label,
  requiredPlaceholder,
}: {
  autoFocus?: boolean;
  className?: string;
  errorMessage: string;
  fieldName: string;
  label: string;
  requiredPlaceholder?: string;
}): JSX.Element | null {
  return (
    <Field
      className={className}
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          autoComplete="name"
          autoFocus={autoFocus}
          className="w-64"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          value={value ? String(value) : ""}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{ required: errorMessage }}
      label={label}
    />
  );
}
